import React from 'react'
import styled from 'styled-components'
import { colors } from '../../Assets/styles/colors'
import { ReactComponent as FileIcon } from "../../Assets/icons/fileIcon.svg"
import { useTranslate } from '@tolgee/react';
import { downloadFile } from '../../Helpers/downloadHelper';

const ReplymessageElement = ({
    text,
    image,
    file,
    messageDeleted,
    forwarded,
    sender,
    received,
    video,
}) => {
    const { t } = useTranslate();

    return (
        <Container>
            <MessageWrapper received={received}>
                <Top imgcontainer={image || video}>
                    <Sender>
                        <h1>{sender}</h1>
                        {image && <p>Image</p>}
                        {video && <p>Video</p>}
                    </Sender>
                    {
                        (image || video || file) &&
                        <ItemWrapper>
                            {image && (
                                <MediaContainer>
                                    <img src={image.url} alt='pht' />
                                    <MiniDownloadBtn 
                                        onClick={(e) => { e.stopPropagation(); downloadFile(image.url, image.name || "image.jpg"); }}
                                    >
                                        ⬇
                                    </MiniDownloadBtn>
                                </MediaContainer>
                            )}
                            
                            {video && (
                                <MediaContainer>
                                    <img src={video.thumbnail?.url || video.video_url} alt='video' />
                                    <MiniDownloadBtn 
                                        onClick={(e) => { e.stopPropagation(); downloadFile(video.video_url, "video.mp4"); }}
                                    >
                                        ⬇
                                    </MiniDownloadBtn>
                                </MediaContainer>
                            )}
                            
                            {file &&
                                <FileWrapper>
                                    <FileIcon />
                                    <p>{file.name}</p>
                                  
                                    <FileDownloadBtn 
                                        onClick={(e) => { e.stopPropagation(); downloadFile(file.url, file.name); }}
                                    >
                                        ⬇
                                    </FileDownloadBtn>
                                </FileWrapper>
                            }
                        </ItemWrapper>
                    }
                </Top>
                {text && text.length > 0 && !image && !video && !file &&
                    <p>{!messageDeleted ? text : <i>{t('chat.message_deleted')}</i>}</p>
                }
            </MessageWrapper>
        </Container >
    )
}

export default ReplymessageElement


const Container = styled.div`
    display:flex;
    flex-direction:column;
    gap:5px;
`

const ItemWrapper = styled.div`
    display:flex;
    flex-direction:column;
    width:100%;
    min-width:100px;
    margin-left:auto;
    overflow:hidden;
    position:relative;

    img {
        object-fit:contain;
        border-radius:4px;
        margin-left:auto;
        max-height:70px;
    }
    
    svg {
        max-height:35px;
        max-width:35px;
        color:${({ theme }) => theme.menu.primaryTextColor};
    }
`

const MediaContainer = styled.div`
    position: relative;
    display: inline-block;
    margin-left: auto;
    
    &:hover button {
        opacity: 1;
    }
`

const MiniDownloadBtn = styled.button`
    position: absolute;
    bottom: 2px;
    right: 2px;
    background: rgba(0,0,0,0.6);
    color: white;
    border: 1px solid white;
    border-radius: 50%;
    width: 20px;
    height: 20px;
    font-size: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    opacity: 0; /* Hidden until hover */
    transition: opacity 0.2s;
    z-index: 10;
    padding: 0;
`

const FileDownloadBtn = styled.button`
    background: rgba(255,255,255,0.2);
    border: none;
    color: white;
    border-radius: 50%;
    width: 24px;
    height: 24px;
    margin-left: auto; /* Push to right */
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    font-size: 14px;
    
    &:hover {
        background: rgba(255,255,255,0.4);
    }
`

const MessageWrapper = styled.div`
    position:relative;
    display:flex;
    flex-direction:${props => props.imgcontainer ? "row" : "column"};
    width:100%;
    gap:${props => props.imgcontainer ? "50px" : "5px"};
    background:${({ theme, received }) => received ? theme.chat.replyElementBgReceived : theme.chat.replyElementBgSent};
    padding: ${(props) => props.imgcontainer ? "8px 12px" : "16px"} ;
    border-top-left-radius:${(props) => props.imgcontainer ? "4px" : "20px"} ;
    border-bottom-left-radius:${(props) => props.imgcontainer ? "4px" : "20px"} ;
    border-top-right-radius:${(props) => props.imgcontainer ? "4px" : "8px"} ;
    border-bottom-right-radius:${(props) => props.imgcontainer ? "4px" : "20px"} ;
    
    p {
        overflow:hidden;
        text-overflow:ellipsis;
        white-space:pre-wrap;
        font-size: 12px;
        font-weight: 400;
        line-height: 16px;
        text-align: left;
        color:white;
    }

    i {
       font-size: 14px; 
       padding:0 5px;
    }

    a {
      color:white;
    }
`

const Sender = styled.div`
    display:flex;
    flex-direction:column;
    gap:5px;
    min-width:70px;
    
    h1 {
        font-size: 14px;
        font-weight: 600;
        line-height: 18px;
        text-align: left;
        color:white;
    }

    p {
        opacity:0.5;
        overflow:hidden;
        text-overflow:ellipsis;
        white-space:pre-wrap;
        font-size: 12px;
        font-weight: 400;
        line-height: 16px;
        text-align: left;
        color:white;
    }
`

const FileWrapper = styled.div`
    display:flex;
    gap:3px;
    align-items:center;
    overflow:hidden;
    width: 100%; /* Ensure it takes width to push button */
    
    p {
        overflow:hidden;
        text-overflow:ellipsis;
        white-space:pre;
        max-width: 80%;
    }
`

const Top = styled.div`
    display:flex;
    width:100%;
    flex-direction:${props => props.imgcontainer ? "row" : "column"};
    position:relative;
    column-gap:25px;
    row-gap:10px;
`
const Bottom = styled(Top)``